"use client";
import { jsx as C } from "react/jsx-runtime";
import { memo as n, forwardRef as i } from "react";
import { useSvgIcon as l } from "../useSvgIcon.js";
const t = n(
  i((o, e) => {
    const r = l({
      ...o,
      ref: e
    });
    return /* @__PURE__ */ C(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...r(),
        children: /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.6567 25.1835H17.5694C17.5694 25.1835 18.147 25.1197 18.4423 24.8019C18.7138 24.5098 18.7051 23.9616 18.7051 23.9616C18.7051 23.9616 18.6677 21.3945 19.8586 21.0165C21.0331 20.6439 22.5409 23.4974 24.139 24.5947C25.3475 25.4248 26.2659 25.2432 26.2659 25.2432L30.5393 25.1835C30.5393 25.1835 32.7747 25.0454 31.7147 23.2874C31.628 23.1439 31.0972 21.987 28.5372 19.6102C25.8574 17.1225 26.2166 17.525 29.4444 13.2219C31.4102 10.6014 32.1959 9.00157 31.9504 8.31641C31.7164 7.6636 30.2705 7.83605 30.2705 7.83605L25.4589 7.86581C25.4589 7.86581 25.102 7.81723 24.8376 7.97548C24.579 8.13022 24.413 8.49179 24.413 8.49179C24.413 8.49179 23.6512 10.5195 22.6359 12.2443C20.4934 15.8832 19.6365 16.0758 19.2863 15.8495C18.4715 15.3228 18.6751 13.7341 18.6751 12.6051C18.6751 9.07844 19.2099 7.60804 17.6337 7.22742C17.1107 7.10119 16.7255 7.01768 15.3878 7.00404C13.6709 6.98657 12.2181 7.00934 11.3953 7.4125C10.8478 7.68063 10.4255 8.27798 10.6829 8.31235C11.001 8.35473 11.721 8.50678 12.1028 9.02636C12.596 9.69754 12.5788 11.2042 12.5788 11.2042C12.5788 11.2042 12.8622 15.3556 11.9171 15.8711C11.2686 16.2248 10.3789 15.5028 8.46866 12.2014C7.49013 10.5103 6.75104 8.64079 6.75104 8.64079C6.75104 8.64079 6.60873 8.29151 6.35451 8.10452C6.04622 7.87798 5.61543 7.80619 5.61543 7.80619L1.043 7.83605C1.043 7.83605 0.356761 7.85521 0.104578 8.15378C-0.119773 8.41955 0.0866629 8.96854 0.0866629 8.96854C0.0866629 8.96854 3.66614 17.3453 7.71955 21.5666C11.4366 25.4375 15.6567 25.1835 15.6567 25.1835Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
t.displayName = "IconVk";
export {
  t as IconVk
};
